"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENHANCED_VERIFIED_LEVEL = exports.VERIFIED_LEVEL = exports.PARTIAL_VERIFIED_LEVEL = exports.UNVERIFIED_LEVEL = exports.TIER_ENHANCED_VERIFIED = exports.TIER_VERIFIED = exports.TIER_UNVERIFIED = void 0;
exports.TIER_UNVERIFIED = 0;
exports.TIER_VERIFIED = 1;
exports.TIER_ENHANCED_VERIFIED = 2;
exports.UNVERIFIED_LEVEL = 'UNVERIFIED';
exports.PARTIAL_VERIFIED_LEVEL = 'PARTIAL_VERIFIED';
exports.VERIFIED_LEVEL = 'VERIFIED';
exports.ENHANCED_VERIFIED_LEVEL = 'ENHANCE_VERIFIED';
